import type { SubTemplateProps } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'

export function FlickrSlideTemplate({ display, controls, slots }: SubTemplateProps) {
  const photo = display.permissions.canViewContent && !display.access.isContentLocked
    ? display.media.primaryAttachment
    : undefined
  const photoSrc = photo?.src || photo?.thumbSrc
  return (
    <>
      <div className={`md-subs-flickr-row group relative m-0 inline-block h-[180px] w-[260px] overflow-hidden bg-[#111] align-top text-xs text-white${display.isChecked ? ' md-subs-flickr-row--checked outline outline-3 -outline-offset-3 outline-[#3897f0]' : ''}`}>
        <div className="md-subs-flickr-fill absolute inset-0 bg-gradient-to-br from-[#202020] to-[#050505]" />
        {photoSrc ? <img className="absolute inset-0 h-full w-full object-cover" src={photoSrc} alt={photo.title || photo.filename || display.title} /> : null}
        <div className="md-subs-flickr-overlay absolute inset-0 bg-black/0 transition group-hover:bg-white/10" />
        <div className="md-subs-flickr-caption absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-3">
          <div className="overflow-hidden text-ellipsis whitespace-nowrap font-semibold [&_.md-sub-title-link]:text-white">{controls.content.title}</div>
          <div className="mt-1 overflow-hidden text-ellipsis whitespace-nowrap text-white/75 [&_.md-sub-text]:inline [&_.md-sub-text]:clear-none [&_.md-sub-text]:text-white/75">{controls.content.text}</div>
          <div className="mt-2 flex items-center gap-2">{controls.actions.check}{controls.actions.favorite}{controls.actions.quickReply}</div>
        </div>
      </div>
      {slots.allChildren}
    </>
  )
}
